export default __webpack_public_path__ + "static/banner3-6a0b6e709754582b5e8cb48b6a1f2148.jpeg";